export default __webpack_public_path__ + "static/media/011_photo.1822d313.jpg";